import getInstanceAxios from '../Request';

export default getInstanceAxios(process.env.REACT_APP_DATA_COMPETITION);
